module.exports = __webpack_public_path__ + "static/media/one-service.a1691e6a.png";